import React, { useEffect } from "react";
import { useMySheetCurrentRoleState } from "my-timesheet/hooks";
import MyTimesheetUserRequestsPage from "my-timesheet/pages/user-requests-page";

export const MyTimesheetViewUserRequestsPage = () => {
  const role = "viewer";
  const { state, setState } = useMySheetCurrentRoleState();

  useEffect(() => {
    if (state !== role) {
      setState(role);
    }
  }, [state]); // eslint-disable-line react-hooks/exhaustive-deps

  return <MyTimesheetUserRequestsPage role={role} />;
};

export default MyTimesheetViewUserRequestsPage;
